import graphql from './graphql';

const query = /* GraphQL */ `
  query User_listCourses($category: String, $name: String) {
    User_listCourses(category: $category, name: $name) {
      id
      name
      description
      updatedAt
      thumbnail
      isDraft
      certificationId
      expirationDate
      userCreatedId
      Priority {
        name
      }
      CourseCategory {
        name
      }
      userCreated {
        id
        fullName
        photo
      }
    }
  }
`;

const UserListCourses = async ({ category = null, name = null }) =>
  graphql(query, { category, name }).then(
    // eslint-disable-next-line camelcase
    ({ User_listCourses }) => User_listCourses
  );

export default UserListCourses;
